import React from "react";
import { useEffect } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import Customers from './Customers';
 import InfinityErrors from './InfinityErrors';
export default function CsystemsMain({
    handleCustomerListCallBack,
    search,
    queryType,
}: {
    handleCustomerListCallBack: (serialNumber: number, queryType: number) => void;
    search: string;
    queryType: number;
}) {
    const [tabType, SetTabType] = React.useState(0);

    const handleTabChange = (event: any, newValue: any) => {
        //SetCurrentPageNuber(0);
        SetTabType(parseInt(newValue));
        //localStorage.setItem("DMSType", newValue);
        // ApplyChanges();
    };


    return (
        // <Box display="flex" justifyContent="center" alignItems="center" ></Box>
        <Box display="flex" style={{ margin: "0px 15px" }} >
            <Box sx={{ width: 'auto', display: "table" }}>
                <Box style={{ marginBottom: "1px" }} sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                        value={tabType}
                        onChange={handleTabChange}
                        aria-label="wrapped label tabs example"
                    >
                        <Tab value={0} label="Customers" />
                        <Tab value={1} label="Errors" />
                        {/* <Tab value={2} label="Ideal" />
                                <Tab value={3} label="Infinity" /> */}
                    </Tabs>
                </Box>
                <Box>
                    {(tabType == 0) && (<Customers handleCustomerListCallBack={handleCustomerListCallBack} search={search} queryType={queryType}></Customers>)}
                    {(tabType == 1) && (<InfinityErrors></InfinityErrors>)}

                </Box>


            </Box>


        </Box>


    )
}